export const voziqOfferSummary = {
    template: require('./voziqOfferSummary.html'),
    bindings: {
        offer: '<'
    }
};
